import { render, staticRenderFns } from "./BnftSrvSttmApp.vue?vue&type=template&id=c5450e2a&"
import script from "./BnftSrvSttmApp.vue?vue&type=script&lang=js&"
export * from "./BnftSrvSttmApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports